import React from 'react';
import thunkMiddleware from 'redux-thunk';
import { parseLocale } from '@tesla/parse-locale';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import App from './containers/App';
import appData from './data/appData.json';
import v1Countries from './data/v1Countries';

// Actions
import {
  setLocationFilters,
  setBounds,
  retrieveLocationDetails,
  updateSearchQuery,
  setZoom,
  initApp,
  initContent,
  initMap,
  retrieveAllLocations,
  setGeolocation,
  setInitialLocation,
  setPlatform,
} from './actions';

// Reducers
import reducers from './reducers';

// Helpers
import { FILTERS } from './constants';
import { parseUrl } from './lib/UrlUtils';

const locale = window.tesla && window.tesla.App ? window.tesla.App.locale : 'en_US';
const { country, lang: language } = parseLocale(locale);

async function getContent() {
  const response = await fetch(`/findus-api/strings?locale=${locale}`);
  const data = await response.json();
  return data;
}

const initFindUsApp = store => {
  const { bounds, filters, place, search, zoom, platform } = parseUrl(
    window.location.href,
    !v1Countries.includes(country)
  );

  // Initialize data.
  store.dispatch(initApp({ country, language, locale, ...appData.app }));
  getContent().then(data => {
    store.dispatch(initContent(data['Find_Us/All']));
  });

  // Initialize map bounds and zoom.
  if (!bounds) {
    store.dispatch(initMap(country));
  }

  // If progressive location querying is not selected, then retrieve all locations data.
  const retrieveAll = !(appData.app.performance && appData.app.performance.progressiveLocations);
  if (retrieveAll) store.dispatch(retrieveAllLocations());

  // If location is set then retrieve location details. If bounds are not set by default, then
  // zoom to this location.
  if (place) {
    store.dispatch(retrieveLocationDetails(place));

    if (!bounds) {
      store.dispatch(setGeolocation(true));
      store.dispatch(setInitialLocation(place));
    }
  }

  // If a search query is provided, then execute that search query.
  if (search) store.dispatch(updateSearchQuery(search));

  let realFilters = filters;

  // Dispatch zoom if initially defined.
  if (platform && platform != null) {
    document.getElementById('tds-header-main').style.display = 'none';
    const localeModal = document.getElementById('locale-modal');
    localeModal.style.display = 'none';
    localeModal.style.height = 0;
    localeModal.style['z-index'] = -1;
    realFilters = ['supercharger'];
    store.dispatch(setPlatform('kiosk'));
  }

  // Dispatch bounds if initially defined.
  if (bounds) {
    store.dispatch(setBounds(bounds));
    store.dispatch(setGeolocation(true));
  }

  // Dispatch zoom if initially defined.
  if (zoom) store.dispatch(setZoom(zoom));

  // Dispatch filters if initially defined, else default to authored default filters.
  return store.dispatch(
    setLocationFilters(realFilters && realFilters.length ? realFilters : FILTERS)
  );
};

const FindUsApp = () => {
  const store = createStore(reducers, applyMiddleware(thunkMiddleware));
  initFindUsApp(store);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

export default FindUsApp;
